// Valstybių kodų sąrašas telefono numerio laukui: kodas + valstybės pavadinimas.
// Lietuva ir kaimyninės/ES šalys viršuje, likusios rikiuotos abėcėliškai.
export const COUNTRY_CODES = [
  { code: "+370", country: "Lietuva" },
  { code: "+371", country: "Latvija" },
  { code: "+372", country: "Estija" },
  { code: "+48", country: "Lenkija" },
  { code: "+49", country: "Vokietija" },
  { code: "+46", country: "Švedija" },
  { code: "+47", country: "Norvegija" },
  { code: "+45", country: "Danija" },
  { code: "+358", country: "Suomija" },
  { code: "+44", country: "Jungtinė Karalystė" },
  { code: "+353", country: "Airija" },
  { code: "+33", country: "Prancūzija" },
  { code: "+34", country: "Ispanija" },
  { code: "+39", country: "Italija" },
  { code: "+31", country: "Nyderlandai" },
  { code: "+32", country: "Belgija" },
  { code: "+41", country: "Šveicarija" },
  { code: "+43", country: "Austrija" },
  { code: "+351", country: "Portugalija" },
  { code: "+30", country: "Graikija" },
  { code: "+420", country: "Čekija" },
  { code: "+421", country: "Slovakija" },
  { code: "+36", country: "Vengrija" },
  { code: "+40", country: "Rumunija" },
  { code: "+359", country: "Bulgarija" },
  { code: "+385", country: "Kroatija" },
  { code: "+386", country: "Slovėnija" },
  { code: "+352", country: "Liuksemburgas" },
  { code: "+356", country: "Malta" },
  { code: "+357", country: "Kipras" },
  { code: "+380", country: "Ukraina" },
  { code: "+375", country: "Baltarusija" },
  { code: "+7", country: "Rusija" },
  { code: "+1", country: "JAV / Kanada" },
  { code: "+55", country: "Brazilija" },
  { code: "+52", country: "Meksika" },
  { code: "+61", country: "Australija" },
  { code: "+64", country: "Naujoji Zelandija" },
  { code: "+81", country: "Japonija" },
  { code: "+82", country: "Pietų Korėja" },
  { code: "+86", country: "Kinija" },
  { code: "+91", country: "Indija" },
  { code: "+90", country: "Turkija" },
  { code: "+971", country: "Jungtiniai Arabų Emyratai" },
  { code: "+972", country: "Izraelis" },
  { code: "+27", country: "Pietų Afrika" },
];
